import { Measures } from './measures';
import { pxToRem } from './utils/pxToRem';

export const Space = {
  half: pxToRem(Measures.spacing[0]),
  x1: pxToRem(Measures.spacing[1]),
  single: pxToRem(Measures.spacing[1]),
  x2: pxToRem(Measures.spacing[2]),
  double: pxToRem(Measures.spacing[2]),
  x3: pxToRem(Measures.spacing[3]),
  triple: pxToRem(Measures.spacing[3]),
  x4: pxToRem(Measures.spacing[4]),
  quadruple: pxToRem(Measures.spacing[3]),
  x5: pxToRem(Measures.spacing[5]),
  quintuple: pxToRem(Measures.spacing[3]),
  x6: pxToRem(Measures.spacing[6]),
  x7: pxToRem(Measures.spacing[7]),
  x8: pxToRem(Measures.spacing[8]),
  x9: pxToRem(Measures.spacing[9]),
  x10: pxToRem(Measures.spacing[10]),
};
